module.exports = __webpack_public_path__ + "img/user-default-avatar.ac1fc173.jpg";